
import { gsap } from 'gsap';
import { Presentation } from '../../../../core/gameflow/controller/Presentation';
import { GameData } from '../../../server/data/GameData';
import { SanQuentin2 } from '../../../SanQuentin2';
import { ResizeHelper } from '../../../../core/utils/ResizeHelper';
import { Helper } from '../../../../core/utils/Helper';
import { SpinePlayer } from '../../../../core/displayobject/SpinePlayer';
import { SoundManager } from '../../../config/sound/SoundManager';
import { SoundConfig } from '../../../config/sound/SoundConfig';
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { OverlayAnimation } from '../../../component/OverlayAnimation';

export class IntroPresentation extends Presentation {
    public static introPlayed = false;
    public static gateSpine:SpinePlayer;
    public introSound = true;

    checkForActivation(data: GameData): boolean {
        if (IntroPresentation.introPlayed) return false;
        let canPlay = !data.isRestoreState && !SanQuentin2.apiPlugin.isReplay && !IntroPresentation.introPlayed;
        canPlay = canPlay && !!SanQuentin2.counter.parent.parent;
        IntroPresentation.introPlayed = true;
        return canPlay;
    }

    public preStart(): void {
        Helper.clicker(SanQuentin2.counter.parent, () => this.skip(),true);
        SlotGame.keypadPlugin.toggleVisibility(false)

        SanQuentin2.reelEngineManager.willPlayIntro(true);

        SanQuentin2.overlay.hideLogo();
        SanQuentin2.xWaysCounter.hide();

        SoundManager.PlayAmbience(SoundConfig.BASE_GAME_AMBIANCE);
        SoundManager.playSoundEffect(SoundConfig.GAME_INTRO_START);
        // SoundManager.playIntro(this.timeline)
    }

    createPresentation(): void {

        // this.timeline.eventCallback("onUpdate",() => {
        //     if(SoundManager.isLoaded() && this.introSound){
        //         SoundManager.playIntro(this.timeline);
        //         this.introSound = false; 
        // }})

        IntroPresentation.playIntroAnimation(this.timeline);
        this.setPlayable(false);
    }

    public static playIntroAnimation(tl:gsap.core.Timeline): void {
        SanQuentin2.overlay.playIntroDarkFade(1);
        tl.fromTo(SanQuentin2.reelEngineManager.reelBGSpine.scale,
            {x:1 * 1.3,y: 1.1 * 1.3},
            {x:1, y:1.1, duration:2},0.5)

        tl.fromTo(SanQuentin2.background.scale,{x:0.85,y:0.85},{x:1,y:1,duration:2},0)
        this.gateSpine = SanQuentin2.overlay.playStandAloneSpine("gates",{animation:"intro"}).item as SpinePlayer;

        if(ResizeHelper.isLandscape){
            this.gateSpine.position.set(420,360);
            this.gateSpine.scale.set( 0.75,1);
        }else{
            this.gateSpine.position.set(350,360);
            this.gateSpine.scale.set( 0.4,1);
          
        }
        tl.add(() => {
            
            SanQuentin2.reelEngineManager.stopTruck();
            SanQuentin2.reelEngineManager.PlayFlash()},"-=0.4");
        tl.add(SanQuentin2.reelEngineManager.PlayIntro(),"-=0.2");
    }

    public skip(): void {
        super.skip();
    }

    public done(): void {
        SlotGame.keypadPlugin.toggleVisibility(true)
        SanQuentin2.reelEngineManager.visible = true;
        if(IntroPresentation.gateSpine){
            IntroPresentation.gateSpine.stop();
        }
        SanQuentin2.overlay.introApplyLogo();
        SanQuentin2.xWaysCounter.counterActive(true,false);
        SanQuentin2.reelEngineManager.willPlayIntro(false);
        Helper.clearClickerFromObj(SanQuentin2.counter.parent);
    }
}
